require('../../modules/es6.object.get-own-property-names');
var $Object = require('../../modules/_core').Object;
module.exports = function getOwnPropertyNames(it) {
  return $Object.getOwnPropertyNames(it);
};



//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/core-js/library/fn/object/get-own-property-names.js
// module id = 1155
// module chunks = 168707334958949